import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { EDITORIAL_FEATURES } from "@/lib/mediaCoverage";

export const MediaStrip = () => (
  <section className="max-w-[1200px] mx-auto px-6 lg:px-12 pb-6" data-testid="about-media-strip">
    <div className="surface px-6 py-5 flex flex-col lg:flex-row lg:items-center gap-4 lg:gap-8">
      <p className="eyebrow shrink-0" style={{ color: "var(--gold)" }}>Featured In The Media</p>
      <div className="flex flex-col sm:flex-row gap-3 sm:gap-6 flex-1 min-w-0">
        {EDITORIAL_FEATURES.map((f) => (
          <a
            key={f.id}
            href={f.url}
            target="_blank"
            rel="noopener noreferrer"
            className="group inline-flex flex-wrap items-baseline gap-x-2 gap-y-0.5 min-w-0"
            data-testid={`media-strip-${f.id}`}
          >
            <span className="font-serif text-lg whitespace-nowrap text-white group-hover:text-[color:var(--gold)] transition-colors">{f.outlet}</span>
            <span className="text-[10px] uppercase tracking-[0.18em] text-white/45">{f.kind}</span>
            <ArrowUpRight size={13} className="text-white/40 group-hover:text-[color:var(--gold)] transition-colors self-center" />
          </a>
        ))}
      </div>
      <Link to="/press" className="text-xs link-gold inline-flex items-center gap-1.5 shrink-0" data-testid="media-strip-press-link">
        Full press archive <ArrowUpRight size={13} />
      </Link>
    </div>
  </section>
);
